import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LOGO = '/dailyreps3.png';

export default function SuperAdminNav({ activeItem, onViewToggle }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const isHome = location.pathname === '/super';

  const viewItems = [
    { label: 'Billing Alerts', key: 'billing' },
    { label: 'Users', key: 'users' },
    { label: 'Security', key: 'security' },
  ];

  const navItems = [
    { label: 'Emails', path: '/super/emails', key: 'emails' },
    { label: 'Manage Demos', path: '/super/demos', key: 'demos' },
    { label: 'Library', path: '/super/library', key: 'library' },
    { label: 'Lessons', path: '/super/lessons', key: 'lessons' },
    { label: 'FAQ', path: '/super/faq', key: 'faq' },
    { label: 'Ads', path: '/super/ads', key: 'ads' },
    { label: 'Promos', path: '/super/promos', key: 'promos' },
    { label: 'Manage Account', path: '/super/account', key: 'account' },
  ];

  return (
    <header className="header">
      <div className="header-left">
        {!isHome && (
          <button className="btn btn-sm btn-outline" onClick={() => navigate('/super')} style={{ marginRight: 8 }}>Home</button>
        )}
        <img src={LOGO} alt="Train Daily" className="header-logo" />
        <div className="header-title"><span>Train Daily</span> Super Admin</div>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        {viewItems.map(({ label, key }) => (
          <button
            key={key}
            className={`btn btn-sm ${activeItem === key ? 'btn-orange' : 'btn-outline'}`}
            onClick={() => onViewToggle ? onViewToggle(key) : navigate('/super')}
          >
            {label}
          </button>
        ))}
        {navItems.map(({ label, path, key }) => (
          <button
            key={key}
            className={`btn btn-sm ${activeItem === key ? 'btn-orange' : 'btn-outline'}`}
            onClick={() => navigate(path)}
          >
            {label}
          </button>
        ))}
        <button className="header-logout" onClick={logout}>Log out</button>
      </div>
    </header>
  );
}
